import React from "react";
import View from "common/View";
import Report from "./Report";
import { flowsStateRetrieval, parseStateActiveSessions } from "./api";
import { bqnIdTarget } from "common/api";
import help from "help/viewFlowsPerProtocol.md";

const retrieval = (mode, bqnId) =>
  flowsStateRetrieval(mode, bqnId)
    .then((response) =>
      parseStateActiveSessions(response, bqnIdTarget(mode, bqnId)))
    .catch((error) => console.error(error) || error);

const ActiveFlowsPerProtocol = () => (
  <View
    title="Active Flows"
    mdHelp={help}
  >
    <Report retrieval={retrieval} />
  </View>
);

export default ActiveFlowsPerProtocol;
